import React from 'react';
import { motion } from 'framer-motion';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-indigo-800 text-white py-16"
    >
      <div className="max-w-screen-xl mx-auto px-6 sm:px-12">
        {/* Footer Top Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 text-center sm:text-left"
        >
          {/* About */}
          <div>
            <h3 className="font-semibold text-2xl mb-4">About Codexa</h3>
            <p className="text-gray-300">
              We are a digital transformation partner focused on delivering cutting-edge solutions. Our team builds websites, apps, and scalable infrastructure.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-2xl mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-indigo-400">Home</a></li>
              <li><a href="/about" className="hover:text-indigo-400">About Us</a></li>
              <li><a href="/services" className="hover:text-indigo-400">Services</a></li>
              <li><a href="/contact" className="hover:text-indigo-400">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-2xl mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li><NavLink to="/web-development" className="hover:text-indigo-400">Web Development</NavLink></li>
              <li><NavLink to="/app-development" className="hover:text-indigo-400">App Development</NavLink></li>
              <li><NavLink to="/Digital-Strategy" className="hover:text-indigo-400">Digital Strategy</NavLink></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-2xl mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li>Email: <a href="mailto:thecodexaoffical@gmail.com" className="hover:text-indigo-400">thecodexaoffical@gmail.com</a></li>
              <li>Phone: +923254472055</li>
              <li>Location: Remote | Global Team</li>
            </ul>
          </div>
        </motion.div>

        {/* Footer Bottom Section with Social Media */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-16 flex flex-col sm:flex-row justify-between items-center text-center sm:text-left"
        >
          <div className="mb-6 sm:mb-0">
            <p className="text-sm text-gray-300">&copy; 2025 Codexa. All rights reserved.</p>
          </div>

          <div className="flex space-x-6">
            <motion.a
              href="https://www.facebook.com/profile.php?id=61576269511525"
              target='_blank'
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.7, duration: 0.8 }}
              className="text-2xl text-gray-300 hover:text-indigo-400"
            >
              <FaFacebook />
            </motion.a>
            <motion.a
              href="https://www.instagram.com/thecodexaoffical/"
              target='_blank'
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.8, duration: 0.8 }}
              className="text-2xl text-gray-300 hover:text-indigo-400"
            >
              <FaInstagram />
            </motion.a>
            <motion.a
              href="https://twitter.com"
              target='_blank'

              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.9, duration: 0.8 }}
              className="text-2xl text-gray-300 hover:text-indigo-400"
            >
              <FaTwitter />
            </motion.a>
            <motion.a
              href="https://www.linkedin.com/company/the-codexa-offical/ "
              target='_blank'
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1, duration: 0.8 }}
              className="text-2xl text-gray-300 hover:text-indigo-400"
            >
              <FaLinkedin />
            </motion.a>
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;
